import { render, staticRenderFns } from "./currency.input.component.vue?vue&type=template&id=130efc57&"
import script from "./currency.input.component.vue?vue&type=script&lang=ts&"
export * from "./currency.input.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports